export default "__VITE_ASSET__8a5828d7__"